exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".goods-template[data-v-5ae1da3c]{min-height:100px;margin-top:-35px}", ""]);

